module.exports = __webpack_public_path__ + "ffd4ab7dcaeef69be9affec3bf27ed63.jpg";